// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__31bik","options":"AnswerScale_options__3lG-0","selected":"AnswerScale_selected__2bhEZ"};